import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PmaDocumentCentreWidgetComponent } from './containers/pma-document-centre-widget/pma-document-centre-widget.component';
import { PmaDocumentCentreWidgetEffects } from '@feature/pma-document-centre/effects/pma-document-centre.effects';
import * as widgetReducer from './reducers/pma-document-centre.reducers';
import { PmaDocumentCentreUploadDialogComponent } from './containers/pma-document-centre-upload-dialog/pma-document-centre-upload-dialog.component';
import { UploadButtonComponent } from './components/upload-button/upload-button.component';
import { PmaDocumentCentrePropertyEditorComponent } from './components/pma-document-centre-property-editor/pma-document-centre-property-editor.component';

@NgModule({
  declarations: [
    PmaDocumentCentreWidgetComponent,
    PmaDocumentCentreUploadDialogComponent,
    UploadButtonComponent,
    PmaDocumentCentrePropertyEditorComponent],
    
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(widgetReducer.pmaDocumentCentreWidgetFeature, widgetReducer.reducer),
    EffectsModule.forFeature([PmaDocumentCentreWidgetEffects])
  ],
  exports: [
    PmaDocumentCentreWidgetComponent
  ],
})

export class PmaDocumentCentreModule { }
